import { AxiosInstance } from 'axios';
import { CreateGroupParams, GroupDTO, UpdateGroupParams } from '../../types/apiType';
import { PaginationConnection, PaginationQueryParams } from '../../types/common';

export default class GroupServices {
  constructor(private axios: AxiosInstance) {}

  getListGroupAdmin = async (params: PaginationQueryParams): Promise<PaginationConnection<GroupDTO>> => {
    const { data } = await this.axios.get('group', { params });
    return data;
  };

  createGroupAdmin = async (params: CreateGroupParams[]): Promise<null> => {
    const { data } = await this.axios.post('group', params);
    return data;
  };

  updateGroupAdmin = async (params: UpdateGroupParams[]): Promise<null> => {
    const { data } = await this.axios.put('group', params);
    return data;
  };

  deleteGroupAdmin = async (ids: string[]): Promise<null> => {
    const { data } = await this.axios.delete('group', { data: ids });
    return data;
  };
}
